import { deepMerge } from 'js/utils/Utils'
import gsap from 'gsap'

const defaults = {
  instanceName: 'careerFaqAccordion',
  $names: {
    panel: '[data-accordion-panel]',
    trigger: '[data-accordion-trigger]',
    body: '[data-accordion-body]',
  },
  duration: 0.4,
  ease: 'power2.out',
  autoCollapseOthers: false, // trueにすると他パネルは自動で閉じる
}

export default class CareerFaqAccordion {
  $contentRoot = document
  $panels = []
  clickHandlers = []

  constructor(options = {}) {
    deepMerge(this, defaults, options)

    this._uid = 0
  }

  init() {
    this._set$()
    this._setAccordion()
  }

  destroy() {
    this._removeEventListeners()
  }

  _set$() {
    this.$panels = this.$contentRoot.querySelectorAll(this.$names.panel)
  }

  _setAccordion() {
    this.$panels.forEach(($panel, i) => {
      const $trigger = $panel.querySelector(this.$names.trigger)
      const $body = $panel.querySelector(this.$names.body)

      if (!$trigger || !$body) return

      const uid = this._generateUid()
      const panelId = $body.id || `CareerFaqBody${uid}`
      const triggerId = $trigger.id || `CareerFaqTrigger${uid}`

      $body.id = panelId
      $trigger.id = triggerId

      $trigger.setAttribute('aria-controls', panelId)
      $trigger.setAttribute('aria-expanded', 'false')
      $body.setAttribute('aria-labelledby', triggerId)
      $body.hidden = true

      gsap.set($body, { height: 0, overflow: 'hidden' })

      const clickHandler = (e) => {
        const isOpen = $trigger.getAttribute('aria-expanded') === 'true'
        if (isOpen) {
          this._close($trigger, $body)
        } else {
          if (this.autoCollapseOthers) this._closeAllExcept($panel)
          this._open($trigger, $body)
        }
      }

      $trigger.addEventListener('click', clickHandler)
      this.clickHandlers.push({ $trigger, handler: clickHandler })
    })
  }

  _removeEventListeners() {
    this.clickHandlers.forEach(({ $trigger, handler }) => {
      $trigger.removeEventListener('click', handler)
    })
    this.clickHandlers = []
  }

  _generateUid() {
    return this._uid++
  }

  _open($trigger, $body) {
    $body.hidden = false
    const fullHeight = $body.scrollHeight

    $trigger.setAttribute('aria-expanded', 'true')
    gsap.fromTo(
      $body,
      { height: 0 },
      {
        height: 'auto',
        duration: this.duration,
        ease: this.ease,
        onComplete: () => {
          $body.style.height = 'auto'
        },
      }
    )
  }

  _close($trigger, $body) {
    const currentHeight = $body.scrollHeight
    $trigger.setAttribute('aria-expanded', 'false')

    gsap.fromTo(
      $body,
      { height: currentHeight },
      {
        height: 0,
        duration: this.duration,
        ease: this.ease,
        onComplete: () => {
          $body.hidden = true
        },
      }
    )
  }

  _closeAllExcept(currentPanel) {
    this.$panels.forEach(($panel) => {
      if ($panel === currentPanel) return
      const $trigger = $panel.querySelector(this.$names.trigger)
      const $body = $panel.querySelector(this.$names.body)
      if ($trigger.getAttribute('aria-expanded') === 'true') {
        this._close($trigger, $body)
      }
    })
  }
}